import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

class ThemeService {
    constructor() {
        this.ariaHidden$ = new BehaviorSubject(0);
        this.ariaHidden = this.ariaHidden$.pipe(map((value) => Boolean(value)));
    }
    /** Makes page tree Aria hidden - to be used in conjunction with a focus trap */
    preventScreenReaderFocus() {
        this.ariaHidden$.next(this.ariaHidden$.value + 1);
    }
    /** Makes page tree aria-accessible */
    allowScreenReaderFocus(force) {
        if (this.ariaHidden$.value > 0) {
            const newValue = force ? 0 : this.ariaHidden$.value - 1;
            this.ariaHidden$.next(newValue);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: ThemeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: ThemeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: ThemeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ThemeService };
